import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component.js"

const PropTypes = require("prop-types")
const propTypesExact = require("prop-types-exact")

class EventListener extends ShapeComponent {
  static propTypes = propTypesExact({
    event: PropTypes.string.isRequired,
    onCalled: PropTypes.func.isRequired,
    target: PropTypes.object.isRequired
  })

  componentDidMount() {
    this.p.target.addEventListener(this.p.event, this.onCalled)
  }

  componentWillUnmount() {
    this.p.target.removeEventListener(this.p.event, this.onCalled)
  }

  onCalled = (...args) => this.p.onCalled(...args)

  render() {
    return null
  }
}

export default React.memo(shapeComponent(EventListener))
